// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let StepCompletion
export default StepCompletion = class StepCompletion extends (
  require("lib/static-shim").default(require("lib/utils/model").default)
) {
  // Note: this model is only used for student submit/reset/view
  url() {
    const { path_id, step_id, completion_id } = this.attributes
    let url = this.urlRoot(
      `/api/private/path/${path_id}/step/${step_id}/completion/`
    )
    const id = completion_id || this.id
    if (id != null) {
      url = `${url}${id}/`
    }
    return url
  }

  isCompleted() {
    return this.get("progress") === 1.0
  }

  isNew() {
    return this.get("progress") < 1
  }
}
